module.exports = __webpack_public_path__ + "static/media/icon_existingUser.4b4bbbaa.svg";